import React, { useMemo } from 'react'
import MirsTable from 'components/general/table/Table'
import Label from "components/general/Label"
import { useViewport } from 'components/general/useViewPort'
import { dateFormat, getDateTimeFormat, isParalympic } from "helpers/utils"
import { useUrlFriendlyToParameters } from 'helpers/urlFriendly'

const getConfiguration = (breakPoint) => {
    const isMobile = (breakPoint === "sm" || breakPoint === "xs")
    let configuration = {
        columns: [],
        sortBy: [{ id: 'RecordName', desc: false }, { id: 'RecordType', desc: false }],
        disableSort: false
    };

    configuration.sortBy = [{ id: 'RecordName', desc: false }, { id: 'RecordType', desc: false }];

    configuration.columns = isMobile ? TableColumnsSM() : TableColumns()
    return configuration;
};


export default function PersonRecords({ data }) {
    const { breakPoint } = useViewport();
    const { mirs_competition } = useUrlFriendlyToParameters();
    const config = useMemo(() => getConfiguration(breakPoint), [breakPoint]);
    let records = data?.person?.records
        ? data?.person?.records?.sort((a, b) => a?.order - b?.order)?.filter(r => {
            const allRecordsOfDiscipline = r?.discipline?.code ? process.env[(isParalympic(mirs_competition) ? 'REACT_APP_RECORDS_PARAS_' : 'REACT_APP_RECORDS_') + r?.discipline?.code]?.split(',') : [];
            return allRecordsOfDiscipline?.includes(r?.recordType?.recordType) && r?.recordData?.find(rd => rd?.current === true && rd?.competitor?.code === data?.person?.code);
        })
        : [];

    return (
        <>

            {records.length > 0 &&
                <>
                    <div id="records"><h2 className="wrsBiosDetail__h2" id="table-biorecords"><Label data="LabelRecords" /></h2></div>
                    < MirsTable
                        data={records}
                        columns={config.columns}
                        initialSortBy={config.sortBy}
                        ariaLabelledby={"table-biorecords"}
                    />
                </>
            }
        </>
    )
}

function TableColumns() {
    return (
        [
            ColumnRecordName(),
            ColumnRecordType(false),
            ColumnRecordValue(),
            ColumnDate(),
            ColumnLocation()
        ]
    )
}

function TableColumnsSM() {
    return (
        [
            ColumnRecordName(),
            ColumnRecordType(true),
            ColumnRecordValue()
        ]
    )
}

function ColumnRecordName() {
    return (
        {
            Header: <Label data="HeaderRecord" />,
            accessor: props => props?.discipline?.code + props?.order,
            className: 'text-start',
            headerClassName: 'text-start w-15',
            disableSortBy: true,
            id: 'RecordName',
            Cell: (props) => {
                const row = props.cell.row.original;
                return row?.record.description;
            }
        }
    )
}

function ColumnRecordValue() {
    const label = "HeaderMark"
    return (
        {
            Header: <Label data={label} legendFixed={true} />,
            accessor: 'record.recordData.result',
            className: 'text-start',
            headerClassName: 'text-start w-10',
            disableSortBy: true,
            id: 'RecordValue',
            Cell: (props) => {
                const row = props.cell.row.original
                const recordData = row?.recordData && row?.recordData.find(r => r.current === true) || {}
                return recordData?.result
            }
        }
    )
}

function ColumnRecordType(isMobile) {
    return (
        {
            Header: <Label data="HeaderType" />,
            // accessor: 'recordType.description',
            accessor: 'order',
            className: 'text-start',
            headerClassName: 'text-start w-10',
            disableSortBy: true,
            id: 'RecordType',
            Cell: (props) => {
                const row = props.cell.row.original
                return (isMobile)
                    ? <abbr title={row?.recordType?.description}>{row?.recordType?.recordType}</abbr>
                    : row?.recordType?.description
                // : `${row?.recordType?.description} - ${row?.order }`

            }
        }
    )
}

function ColumnLocation() {
    return (
        {
            Header: <Label data="HeaderPlace" />,
            accessor: 'record.recordData.place',
            className: 'text-start',
            headerClassName: 'text-start w-25',
            disableSortBy: true,
            id: 'Location',
            Cell: (props) => {
                const row = props.cell.row.original
                const recordData = row?.recordData && row?.recordData.find(r => r.current === true) || {}
                return recordData?.place
            }

        }
    )
}

function ColumnDate() {
    return (
        {
            Header: <Label data="HeaderDate" />,
            accessor: 'record.recordData.recordDate',
            className: 'text-start',
            headerClassName: 'text-start w-10',
            disableSortBy: true,
            id: 'Date',
            Cell: (props) => {
                const row = props.cell.row.original
                const formatDate = getDateTimeFormat('DayMonthShortYear');
                const recordData = row?.recordData && row?.recordData.find(r => r.current === true) || {}
                return recordData?.recordDate && dateFormat(recordData?.recordDate, "", formatDate);
            }
        }
    )
}

